import { useState } from 'react'
import { Divider, Typography } from '@mui/material'
import { TableMuiLabel } from 'src/components/TableMui/styles'
import { ProductWrong, UnreceivedProduct, WrongProductData } from '../../../PendingReceivementsTypes'
import { TableFooter, TableFooterRow } from '../ReceivementConferenceTables/ReceivementConferenceTables.style'
import { useSelector } from 'src/utils/store'
import { actions } from '../../../PendingReceivementsState'
import { useDispatch } from 'react-redux'
import { capitalizeString } from 'src/utils/capitalize'
import TableMui from 'src/components/TableMui'
import theme from 'src/styles/theme'
import UnreceivedProductsListModal from 'src/features/pending-receivements/components/UnreceivedProductsListModal/UnreceivedProductsListModal'
import ConfirmOrRejectModal from 'src/features/base/components/ConfirmOrRejectModal'
import WithoutUnreceivedProductsModal from 'src/features/pending-receivements/components/WithoutUnreceivedProductsModal/WithoutUnreceivedProductsModal'
import * as S from './WrongProductsTables.styles'

interface WrongProductsTablesProps {
  wrongProducts?: ProductWrong[]
  receivementId: string | undefined
  badge: string | undefined
}

export const WrongProductsTables = ({ wrongProducts, receivementId, badge }: WrongProductsTablesProps) => {
  const [openUnreceivedProductsListModal, setOpenUnreceivedProductsListModal] = useState(false)
  const [openWithoutUnreceivedProductsModal, setOpenWithoutUnreceivedProductsModal] = useState(false)
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [wrongProductData, setWrongProductData] = useState<WrongProductData>()
  const { receivementConference } = useSelector((state) => state.pendingReceivements)
  const dispath = useDispatch()

  const unreceivedProducts: UnreceivedProduct[] = []

  receivementConference?.receivementConference.forEach((receivement) => {
    receivement.invoiceDetails.forEach((invoiceDetail) => {
      if (invoiceDetail.receivedQuantity === 0) {
        const unreceivedProduct: UnreceivedProduct = {
          idModel: receivement.modelId,
          idArItem: invoiceDetail.idArItem,
          invoiceNumber: invoiceDetail.invoiceNumber,
          invoiceProductName: invoiceDetail.invoiceProductName,
          invoiceUnitType: invoiceDetail.invoiceUnitType,
          originalQuantity: invoiceDetail.boxQuantity,
          convertedQuantity: invoiceDetail.convertedQuantity,
        }
        unreceivedProducts.push(unreceivedProduct)
      }
    })
  })

  const openUnreceivedProductsListModalHandler = (data: WrongProductData) => {
    setWrongProductData(data)

    if (unreceivedProducts.length > 0) {
      setOpenUnreceivedProductsListModal(true)
      return
    }

    setOpenWithoutUnreceivedProductsModal(true)
  }

  const closeConfirmModal = () => setShowConfirmModal(false)

  const onSubmitConfirmWrongProduct = (idProductDivergence: number) => {
    if (!badge) return
    setShowConfirmModal(false)
    dispath(actions.confirmWrongProduct({
      badge,
      idProductDivergence,
      onSuccess: closeConfirmModal,
    }))
  }

  const openConfirmModal = (data: WrongProductData) => {
    setShowConfirmModal(true)
    setWrongProductData(data)
  }

  return (
    <>
      {wrongProducts?.map((product: ProductWrong) => {
        const data: WrongProductData = {
          description: product.description,
          modelId: product.modelId,
          idProductDivergence: product.idProductDivergence,
          productCode: product.productCode,
        }
        return (
          <div>
            <TableMui
              key={product.modelId}
              testId='wrong-product-table-test-id'
              columns={[
                { id: 'idAr', label: 'AR', width: '25%' },
                { id: 'qtyPerBox', label: 'Caixaria', width: '25%' },
                { id: 'boxQuantity', label: 'Qtd. Caixas', width: '25%' },
                { id: 'expectedQuantity', label: 'Qtd. Esperada', width: '25%' },
              ]}
              columnsStyle={{ padding: 8 }}
              tableLabel={(
                <TableMuiLabel backgroundColor={theme.colors.red} data-testid='wrong-product-label'>
                  {`${product.modelId} - ${product.description}`}
                </TableMuiLabel>
              )}
              tableFooter={(
                <TableFooter>
                  <Divider />
                  <TableFooterRow>
                    <Typography color={theme.colors.red2} pl={1}>
                      Produto Errado - Não estará incluído na nota de devolução
                    </Typography>
                  </TableFooterRow>
                  <S.ContainerButtons>
                    <S.CustomButton
                      title='Corrigir produto'
                      bgColor='darkBlue'
                      hoverColor='darkBlueHover'
                      letterColor='white'
                      data-testid='fix-product-button-test-id'
                      onClick={() => openUnreceivedProductsListModalHandler(data)}
                    />
                    <S.CustomTooltip arrow title={product.wrongProductConfirmed ? 'Produto errado já confirmado' : ''}>
                      <div>
                        <S.CustomButton
                          title='Confirmar produto errado'
                          bgColor='confirm'
                          hoverColor='confirmHover'
                          letterColor='white'
                          data-testid='confirm-wrong-product-button-test-id'
                          onClick={() => openConfirmModal(data)}
                          disabled={product.wrongProductConfirmed}
                        />
                      </div>
                    </S.CustomTooltip>
                  </S.ContainerButtons>
                </TableFooter>
                )}
              thinLine
            />
            {
              wrongProductData && (
                <ConfirmOrRejectModal
                  show={showConfirmModal}
                  title='Confirmação de produto errado'
                  customizableDescription={(
                    <S.ContainerDescription>
                      <p>
                        Deseja confirmar que o produto <strong>{capitalizeString(wrongProductData.description)}</strong> está realmente errado?
                      </p>
                    </S.ContainerDescription>
                  )}
                  onConfirm={() => onSubmitConfirmWrongProduct(wrongProductData.idProductDivergence)}
                  onReject={closeConfirmModal}
                  onClose={closeConfirmModal}
                  dataTestId='confirm-wrong-product-modal-test-id'
                />
              )
            }

            {wrongProductData && receivementId && badge && (
              <UnreceivedProductsListModal
                show={openUnreceivedProductsListModal}
                onClose={() => setOpenUnreceivedProductsListModal(false)}
                unreceivedProducts={unreceivedProducts}
                receivementId={receivementId}
                wrongProductData={wrongProductData}
                badge={badge}
              />
            )}

            <WithoutUnreceivedProductsModal
              show={openWithoutUnreceivedProductsModal}
              onClose={() => setOpenWithoutUnreceivedProductsModal(false)}
            />
          </div>
        )
      })}
    </>
  )
}
